import { SlackNotifySettings } from '../../Model/SlackNotifySettings';
import { AccountRepository } from '../Repositories/AccountRepository';

export class GetSlackNotifySettingsUseCase {
  constructor(private readonly repo: AccountRepository) {}

  execute(): Promise<SlackNotifySettings> {
    return this.repo.getSlackNotifySettings();
  }
}
